import { registerComponent } from '../registry';
import { COMPONENT_TYPES } from '../../../constants';
import ImageTextComponent from './ImageText.component';
import ImageTextEditor from './ImageText.editor';
import ImageTextProperties from './ImageText.properties';

// 컴포넌트 내보내기
export { default as ImageTextComponent } from './ImageText.component';

// 레지스트리에 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.IMAGE_TEXT,
  component: ImageTextComponent,
  editorComponent: ImageTextEditor,
  properties: ImageTextProperties,
  name: '이미지-텍스트',
  category: 'content',
  icon: '🖼️',
  defaultProps: {
    content: '<h3>제목을 입력하세요</h3><p>여기에 내용을 입력하세요. <strong>굵게</strong> 또는 <em>기울임꼴</em>로 강조할 수 있습니다.</p>',
    componentProps: {
      imageUrl: 'https://via.placeholder.com/400x300',
      imagePosition: 'left',
      imageWidth: '50%',
      textWidth: '50%',
      gap: '20px',
      verticalAlign: 'middle',
      useSecondImage: false
    },
    style: {
      width: '100%',
      padding: '20px',
      boxSizing: 'border-box',
    }
  }
}); 